import React from "react";
import { Table } from "reactstrap";
import TTResults from "../containers/ttResults";
import ScractchResults from "../containers/scratchResults";
import KeirinResults from "../containers/keirinResults";
import PointsRaceResults from "../containers/pointsraceResults";
import SprintTournamentResults from "../containers/sprintTournamentResults";
// import propTypes from "prop-types";


const Live = (props) => {
  const {
    dataLive,
    dataLive2,
    EventLive,
  } = props;

  return (
    // <div>
    //   <table>
    //     <thead>
    //       <tr>
    //         <th>Nombre 1</th>
    //         <th>Nombre 2</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr>
    //         <td>
    //           {dataget1.value}
    //         </td>
    //         <td>
    //           {dataget2.value}
    //         </td>
    //       </tr>
    //     </tbody>
    //   </table>
    // </div>    
    <div className="container">

      {!EventLive.raceCode && <div>
        <br></br>
        <br></br>
        <div>
          <h1 className="text-center">No live event</h1>
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>}

      {EventLive.Type === 105 && <div>
        <div>
          <h2 id="homeheatname">{dataLive.liveHomeLine && dataLive.liveHomeLine.heatname} </h2>
          <h3>Home Straight</h3>
          <div id="msgList">

          </div>
          <Table>
            <thead>
              <tr className="d-flex">
                <th className="col-md-1">rank</th>
                <th className="col-md-1">bib</th>
                <th className="col-md-4">Name</th>
                <th className="col-md-2">Time</th>
                <th className="col-md-2">Nat</th>
                <th className="col-md-1">Speed</th>
                <th className="col-md-1">diff</th>
              </tr>
            </thead>
            <tbody>
              <tr className="d-flex">
                <td className="col-md-1" id="homerank">{dataLive.liveHomeLine && dataLive.liveHomeLine.rank}</td>
                <td className="col-md-1" id="homebib">{dataLive.liveHomeLine && dataLive.liveHomeLine.bib}</td>
                <td className="col-md-4" id="homename">{dataLive.liveHomeLine && dataLive.liveHomeLine.name}</td>
                <td className="col-md-2" id="hometime">{dataLive.liveHomeLine && dataLive.liveHomeLine.time}</td>
                <td className="col-md-2" id="homenation">
                  {dataLive.liveHomeLine && <img
                    src={process.env.PUBLIC_URL + '/Flags/' + dataLive.liveHomeLine.nation + '.bmp'}
                    height="25"
                    width="60"
                    alt={dataLive.liveHomeLine.nation}
                  />}
                </td>
                <td className="col-md-1" id="homespeed">{dataLive.liveHomeLine && dataLive.liveHomeLine.speed}</td>
                <td className="col-md-1" id="homediff">{dataLive.liveHomeLine && dataLive.liveHomeLine.diff}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <br></br>
        <div>
          <h3>Back Straight</h3>
          <Table>
            <thead>
              <tr className="d-flex">
                <th className="col-md-1">rank</th>
                <th className="col-md-1">bib</th>
                <th className="col-md-4">Name</th>
                <th className="col-md-2">Time</th>
                <th className="col-md-2">Nat</th>
                <th className="col-md-1">Speed</th>
                <th className="col-md-1">diff</th>
              </tr>
            </thead>
            <tbody>
              <tr className="d-flex">
                <td className="col-md-1" id="backrank">{dataLive2.liveBackLine && dataLive2.liveBackLine.rank}</td>
                <td className="col-md-1" id="backbib">{dataLive2.liveBackLine && dataLive2.liveBackLine.bib}</td>
                <td className="col-md-4" id="backname">{dataLive2.liveBackLine && dataLive2.liveBackLine.name}</td>
                <td className="col-md-2" id="backtime">{dataLive2.liveBackLine && dataLive2.liveBackLine.time}</td>

                <td className="col-md-2" id="backnation">
                  {dataLive2.liveBackLine && <img
                    src={process.env.PUBLIC_URL + '/Flags/' + dataLive2.liveBackLine.nation + '.bmp'}
                    height="25"
                    width="60"
                    alt={dataLive2.liveBackLine.nation}
                  />}
                </td>
                <td className="col-md-1" id="backspeed">{dataLive2.liveBackLine && dataLive2.liveBackLine.speed}</td>
                <td className="col-md-1" id="backdiff">{dataLive2.liveBackLine && dataLive2.liveBackLine.diff}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>
      }

      <br></br>
      {EventLive.Type === 105 && <div>
        <TTResults raceCode={EventLive.raceCode} fase={EventLive.Fase} />
      </div>}
      {(EventLive.Type === 4 || EventLive.Type === 5) && <div>
        <ScractchResults raceCode={EventLive.raceCode} />
      </div>}
      {EventLive.Type === 6 && <div>
        <KeirinResults raceCode={EventLive.raceCode} />
      </div>}
      {(EventLive.Type === 7 || EventLive.Type === 8 || EventLive.Type === 9) && <div>
        <PointsRaceResults raceCode={EventLive.raceCode} />
      </div>}
      {EventLive.Type === 11 && <div>
        <SprintTournamentResults raceCode={EventLive.raceCode} />
      </div>}
    </div>
  );
};

export default Live;  